import { forwardRef, useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { Flex } from "../../../Flex/Flex.js";
import { ICONSAX_SIZE } from "../../../Iconsax/Iconsax.types.js";
import { Popover } from "../../../Popover/Popover.js";
import { useSidebar } from "../../Sidebar.context.js";
import { AnimatedIcon, StyledBrandImage, StyledSidebarBrandContainer, StyledTitle, StyledTitleWrapper } from "./SidebarBrand.style.js";
import { SidebarBrandProps } from "./SidebarBrand.types.js";

export const SidebarBrand = forwardRef<HTMLDivElement, SidebarBrandProps>(
    ({ logo, title, crossSelling = false, crossSellDropdown, ...attributes }, ref): JSX.Element => {
        const { transitionState, transitionDuration, crossSellPopoverRef } = useSidebar();
        const theme = useTheme();
        const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);

        useEffect(() => {
            if (transitionState === "exiting" || transitionState === "exited" || transitionState === "unmounted")
                crossSellPopoverRef.current?.close();
        }, [transitionState]);

        const brandComponents = (
            <StyledSidebarBrandContainer {...attributes} ref={ref} transitionState={transitionState} transitionDuration={transitionDuration}>
                {typeof logo === "string" ? <StyledBrandImage src={logo} alt="logo" /> : logo}
                <StyledTitleWrapper align="center" justify="center">
                    {typeof title === "string" ? <StyledTitle src={title} alt="title" /> : title}
                </StyledTitleWrapper>
                {crossSelling ? (
                    <Flex justify="center" align="center">
                        <AnimatedIcon $isOpen={isPopoverOpen} size={ICONSAX_SIZE.SMALL} color={theme.colors.primary[100]} />
                    </Flex>
                ) : null}
            </StyledSidebarBrandContainer>
        );

        if (!crossSelling) return brandComponents;

        return (
            <Popover
                dropdownContent={crossSellDropdown}
                positions={["bottom"]}
                open={isPopoverOpen}
                onOpenChange={setIsPopoverOpen}
                ref={crossSellPopoverRef}
                style={{ padding: theme.spacing[4] }}
                hideArrow
                align="start"
                positionTop="20px"
            >
                {brandComponents}
            </Popover>
        );
    },
);
